import React, { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useToast } from '~/lib/ui/toast'
import { cn } from '~/lib/utils'
import YnsIcon from '../icons/YnsIcon'

const Dropzone = ({
  selectedFiles,
  setSelectedFiles,
  className,
  label,
  supportedDocFiles = [],
  meetingViaCalendly,
  children,
}) => {
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { toast } = useToast()

  const onDropAccepted = (incomingFiles) => {
    setSelectedFiles([...selectedFiles, ...incomingFiles])
  }

  const onDropRejected = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]
    const description = errors.map((e) => ` • ${e.message}`).join('\n')
    console.error('File upload rejected:', description)
    if (type) {
      toast({
        description,
        title: 'File attachment failed',
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 5,
    accept: {
      '*/*/pdf': ['.pdf'],
      '*/*/msword': ['.doc'],
      '*/*/document': ['.docx'],
    },
    onDropAccepted,
    onDropRejected,
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxSize: 15_000_000, // 15MB
  })

  const baseRootClassName = cn(
    'min-h-[10rem] p-4 border-black/50 rounded-lg border-dashed border-2 text-center content-center justify-items-center cursor-pointer',
    className,
  )
  const rootClassName = isDraggingOver
    ? cn(baseRootClassName, 'border-primary bg-lily-blue')
    : baseRootClassName

  const filteredSupportedDocFiles = supportedDocFiles.filter(
    (file) => !(meetingViaCalendly && file.electronic_only),
  )

  return (
    <div className="pb-4">
      <div className="mb-2 flex flex-row items-center justify-start">
        <div className="text-lg font-medium">{label || 'File Attachments'}</div>
      </div>
      {filteredSupportedDocFiles.length > 0 && (
        <>
          <div className="mb-2 italic">
            Please download and review the following file(s). You may include
            the file(s) in your feedback to the candidate if appropriate.
          </div>
          <div className="mb-2 flex flex-col gap-1">
            {filteredSupportedDocFiles.map((file, idx) => (
              <a
                key={file.path || idx}
                href={file.path}
                className="inline-flex items-center"
              >
                <YnsIcon
                  name="Download"
                  className="mr-1 inline-block h-5 w-5"
                />
                {file.fileName || file.path}
              </a>
            ))}
          </div>
        </>
      )}
      <div
        {...getRootProps({
          className: rootClassName,
        })}
      >
        <input {...getInputProps()} />
        <div>
          {children}
          <em>(Files must be in .pdf, .doc, or .docx format)</em>
        </div>
      </div>
    </div>
  )
}
export default Dropzone
